import React, { PropTypes, Component } from 'react'
import constants from '../constants'
import styled from 'styled-components'

const CountdownWrapper = styled.div`
  position: relative;
  z-index: 50;
  text-align: right;
  padding: 6px;
  > * + * {
    margin-top: 4px;
  }
  @media (max-width: 767px) {
    max-width: calc(50% - 30px);
  }
`
const Next = styled.span`
  display: inline-block;
  transition: opacity 0.3s;
  animation: fade-in 0.3s;
`
const Divider = styled.span`
  @media (max-width: 767px) {
    display: none;
  }
`
const Title = styled.span`
  @media (max-width: 767px) {
    display: block;
  }
`
const Track = styled.span`
  @media (max-width: 767px) {
    display: block;
  }
`

const Time = styled.span`
  @media (max-width: 767px) {
    display: block;
  }
`

class Countdown extends Component {
  render () {
    let {active, animating, time, next} = this.props
    return (
      <CountdownWrapper>
        {next && !animating && active === constants.SHOW_OVERLAY && <Next active={active} animating={animating}>
          <Title className='Text Text--Pink'>Next</Title> <Track className='Text'>{next.title}</Track>
          <Divider className='Text Text--Grey'> / </Divider>
        </Next>}
        {time && <Time className='Text Text--Grey'>{time}</Time>}
      </CountdownWrapper>
    )
  }
}

Countdown.propTypes = {
  time: PropTypes.string,
  active: PropTypes.string,
  animating: PropTypes.bool,
  next: PropTypes.object
}

export default Countdown



/** WEBPACK FOOTER **
 ** ./src/components/Countdown.js
 **/